<div class="menu-stick-placeholder" [style.height.px]="isSticky ? navHeight : 0"></div>
<nav #navBar class="sub-navigation-bar" [class.menu-sticky]="isSticky" [style.background-color]="color">
    <div class="nav-container" [class.sticky]="isSticky">
          
        <div class="icono-facultad desk">
            <img *ngIf="svgContent" [src]="svgContent" />
        </div>

        <!-- Título que figura en Figma en el Submenú Mobile -->
        <div class="nav-brand quicksand-bold" *ngIf="isSticky">
              <div class="icono-facultad">
                  <img *ngIf="svgContent" [src]="svgContent" />
              </div>
            Facultad Ciencias Económicas
        </div>

        <!-- Botón Hamburguesa / X (solo visible en Mobile) -->
        <button class="hamburger-btn" (click)="toggleMenu()" [class.active]="isMenuOpen" aria-label="Toggle navigation">
            <span class="bar"></span>
            <span class="bar"></span>
            <span class="bar"></span>
        </button>

 

        <!-- Contenedor del menú (Desktop en línea / Mobile desplegable) -->
        <div class="nav-menu" [style.background-color]="color" [class.open]="isMenuOpen">
            <div class="nav-item quicksand-medium" *ngFor="let btn of items">
                
                <!-- Enlace URL -->
                <a *ngIf="btn.typeLink == 'url'" 
                   [href]="url(btn)" 
                   [target]="'_blank'"
                   (click)="handleClick($event, btn)">
                   {{ btn.label }}
                </a>

                <!-- Enlace Ancla -->
                <a *ngIf="btn.typeLink == 'anchor'" 
                   href="javascript:void(0)" 
                   (click)="handleClick($event, btn)">
                   {{ btn.label }}
                </a>

            </div>
        </div>

    </div>
</nav>
